import type { PublicBrandNavigationFacet } from "../../openapi/shop_agent/client/types.gen";

/** Recorded assortment describes navigation, without promising scoped inventory. */
export function brandShoppingOptions(facets: PublicBrandNavigationFacet[]) {
  const values = (name: string) =>
    new Set(facets.filter((f) => f.name === name).flatMap((f) => f.values));
  const genders = values("gender");
  const ages = values("age_groups");
  return {
    has_menswear: ages.has("adult") && (genders.has("male") || genders.has("unisex")),
    has_womenswear: ages.has("adult") && (genders.has("female") || genders.has("unisex")),
    has_kidswear: ["infant", "toddler", "kids"].some((age) => ages.has(age)),
    has_beauty: values("category_path.depth_0").has("beauty"),
  };
}
